
const TWITTER = {
  icon: "twitter",
  name: "twitter",
  url: "https://twitter.com/Overlook_Team"
}
const TWITCH = {
  icon: "twitch",
  name: "twitch",
  url: "https://www.twitch.tv/overlookstudios"
}
const REDDIT = {
  icon: "reddit-alien",
  name: "reddit",
  url: "https://www.reddit.com/user/Overlook-Studios"
}
const STEAM = {
  icon: "steam",
  name: "steam",
  url: null,
  disabled: true
}
const ALL_SOCIALS = [
  TWITTER,
  TWITCH,
  REDDIT,
  STEAM
]

export default {
  SOCIALS: {
    TWITTER,
    TWITCH,
    REDDIT,
    STEAM
  },
  ALL_SOCIALS
}